export function ExpiringPointModel() {
    this.point = 0;
    this.dateExpire = null;

    this.setDataFromApi = function (data) {
        this.point = data.expiring_points.points;
        this.dateExpire = data.expiring_points.time;
    };
}

export function ProfileExpirePoint() {
    this.name = null;
    this.userId = null;
    this.expiringPointList = [];
    this.point = 0;
    this.updateTime = null;

    this.setDataFromApi = function (data) {
        this.name = data.profile.Name;
        this.userId = data.profile.UserId;
        this.point = data.updated_points.points;
        this.updateTime = data.updated_points.time;

        let expiringList = [];
        for (let i of data.expiring_points) {
            let expirePoint = new ExpiringPointModel();
            expirePoint.point = i.points;
            expirePoint.dateExpire = i.time;
            expiringList.push(expirePoint);
        }
        this.expiringPointList = expiringList;
    };
}
